export enum MouseEventType {
  DRAG_START = 'dragstart',
  DRAG_END = 'dragend',
  DRAG_OVER = 'dragover',
  DROP = 'drop',
}
